import React from 'react';
import { X } from 'lucide-react';

const AuthDialog = ({ onClose, onSuccess }) => {
  const handleGoogleLogin = () => {
    const authUrl = process.env.REACT_APP_AUTH_URL || 'https://auth.emergentagent.com';
    const redirectUrl = `${window.location.origin}/auth/callback`;
    window.location.href = `${authUrl}/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-testid="auth-dialog">
      <div className="glass-card p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          data-testid="close-auth-dialog"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Save Your Decision
          </h2>
          <p className="text-gray-600 mb-6">
            Create a free account to save your decision and track outcomes over time.
          </p>

          <button
            onClick={handleGoogleLogin}
            className="btn-primary w-full"
            data-testid="google-login-btn"
          >
            Continue with Google
          </button>

          <p className="text-sm text-gray-500 mt-4">
            By continuing, you agree to track your decisions and outcomes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthDialog;
